import { ModuleId, configModule } from '@wix/business-manager-api';
import { ModuleInitFn } from 'yoshi-flow-bm-runtime';

const CONTACT_INVOICES_TAB_COMPONENT = 'contact-invoices-tab';

export const init: ModuleInitFn = (flowAPI) => {
  configModule(ModuleId.Invoices, ModuleId.Contacts, {
    componentName: CONTACT_INVOICES_TAB_COMPONENT,
    type: 'contact-page-tab-widget',
    tabName: async () => {
      const i18n = await flowAPI.getI18n();
      return i18n.t('contact-invoices.tab-name');
    },
    shouldRender: async () => {
      const experiments = await flowAPI.getExperiments();
      return experiments.enabled('specs.crm.InvoicesTabInContacts');
    },
  });
};
